import * as React from 'react';
import { useSelector } from 'react-redux';
import { REDUCER_GLOBAL_NAME } from 'moduleBase/constants';
import { LangsMenuItem } from 'moduleBase/components/header/components/LangsMenu/LangsMenuItem';

var LangsMenuList = function LangsMenuList() {
  var languageSettings = useSelector(function (state) {
    return state[REDUCER_GLOBAL_NAME].languageSettings;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, languageSettings.list.map(function (language) {
    return /*#__PURE__*/React.createElement("li", {
      key: language.name
    }, /*#__PURE__*/React.createElement(LangsMenuItem, {
      currentPageUrl: language.currentPageUrl,
      isActive: language.isActive,
      name: language.name
    }));
  }));
};

export { LangsMenuList };